import Appbooksys from "../images/Appbooksys.jpeg";
import mrmd from "../images/mrmd.jpeg";

export const Bio = {
  name: "Akhil Ben Thomas",
  roles: [
    "Data Science",
    "Full Stack Development",
    "Cyber Security",
    "Web 3.0",
    "Programming",
  ],
  description:
    "I am an Ambitious, Impactful, Motivated and Versatile individual, always eager to take on new challenges. With great passion for learning, I am dedicated to delivering high-quality results with a positive attitude and a growth mindset. Ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/akhilx26",
  resume:
    "https://docs.google.com/document/d/1xh7Z9w_AppP54dcRvigAlFfp9mpufVNd9LHvevN3MeM/edit?usp=sharing",
  linkedin: "https://www.linkedin.com/in/akhil-ben-thomas-b02304216/",
  insta: "https://www.instagram.com/xxakhill/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "TypeScript",
        image:
          "https://w7.pngwing.com/pngs/74/362/png-transparent-typescript-plain-logo-icon-thumbnail.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "MariaDB",
        image:
          "https://mariadb.com/wp-content/uploads/2019/11/mariadb-logo-vert_blue-transparent.png",
      },
      {
        name: "Spring Boot",
        image:
          "https://dz2cdn1.dzone.com/storage/temp/12434118-spring-boot-logo.png",
      },
    ],
  },
  {
    title: "Programming",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://w7.pngwing.com/pngs/74/362/png-transparent-typescript-plain-logo-icon-thumbnail.png",
      },
    ],
  },
  {
    title: "Web 3.0",
    skills: [
      {
        name: "Blockchain",
        image: "https://cdn-icons-png.flaticon.com/512/2810/2810182.png",
      },
      {
        name: "Solidity",
        image: "https://www.svgrepo.com/show/374088/solidity.svg",
      },
      {
        name: "ThirdWeb",
        image: "https://asset.brandfetch.io/id9zhq9tob/idKoHQDdA4.jpeg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/685/833/png-clipart-red-sign-logo-git-logo-icons-logos-emojis-tech-companies-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "GitLab",
        image:
          "https://w7.pngwing.com/pngs/535/202/png-transparent-gitlab-logo-version-control-company-react-others-miscellaneous-angle-company.png",
      },
      {
        name: "Playwright Automation",
        image: "https://playwright.dev/img/playwright-logo.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png",
      },
      {
        name: "Figma",
        image:
          "https://w7.pngwing.com/pngs/911/515/png-transparent-figma-logo-brand-logos-brands-in-colors-icon-thumbnail.png",
      },
      {
        name: "Power Point Presentation",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Microsoft_Office_PowerPoint_%282019%E2%80%93present%29.svg/512px-Microsoft_Office_PowerPoint_%282019%E2%80%93present%29.svg.png?20210821050414",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://i.redd.it/verizons-logo-over-the-years-v0-vqzups8vs49d1.jpg?width=2560&format=pjpg&auto=webp&s=d3ae8ed2bd281f96055beac2f694d923380f438f",
    role: "Engr I - Software Development",
    company: "Verizon Communications Inc.",
    date: "July 2024 - Present",
    // skills: [],
  },
  {
    id: 1,
    img: "https://i.redd.it/verizons-logo-over-the-years-v0-vqzups8vs49d1.jpg?width=2560&format=pjpg&auto=webp&s=d3ae8ed2bd281f96055beac2f694d923380f438f",
    role: "Software Development Intern - Full Stack",
    company: "Verizon Communications Inc.",
    date: "February 2024 - July 2024",
    skills: [
      "Java",
      "Spring Boot",
      "ReactJS",
      "Javascript",
      "Typescript",
      "Figma",
      "Postman",
      "RESTful APIs",
      "UI/UX",
      "Git"
    ],
  },
  {
    id: 2,
    img: "https://alcovex.studio/assets/alcovex-logo.png",
    role: "Quality Analyst Intern",
    company: "AlcoveX Product Studio, Visakhapatnam",
    date: "May 2023 - July 2023",
    desc: "Quality Analyst for InterviewBuddy™. A NASSCOM startup that offers virtual face-to-face practice interviews with industry experts over various domains. Performed tests, Identified and Documented bugs/inconsistencies, Created detailed, comprehensive, and well-structured test plans and test cases. Coordinated with the development team to get the bugs/inconsistencies fixed",
    skills: [
      "Agile Methodologies",
      "Software Testing",
      "Test Case Authoring",
      "Documentation",
      "Testing Automation",
      "Playwright Automation",
      "Cross-Functional Communication",
      "Team Dynamics",
    ],
    doc: "https://drive.google.com/file/d/1ne2waPBK9e0sMthvIWC3-a5xmbrdljHM/view?usp=sharing",
    icon: "https://img.freepik.com/premium-vector/certificate-icon-with-ribbon-medal-flat-design_115464-65.jpg",
  },
  {
    id: 3,
    img: "https://media1-production-mightynetworks.imgix.net/asset/23564598/isac_logo_400_px_Proxy.png?ixlib=rails-4.2.0&auto=format&w=512&h=512&fit=crop&impolicy=Avatar",
    role: "Research Intern",
    company: "Information Sharing and Analysis Center (ISAC)",
    date: "September 2022 - December 2022",
    desc: "Assisting Police and Law Enforcement Agencies, Collaborated with Cyber Security Experts to bring awareness about Cyber Safety. Research about various  Cyber Crimes, their modus operandi and Comprehensive documentation. Completed Cyber Crime Intervention Officer and Certification on Professional Ethics at Workplace certifications.",
    skills: [
      "Research",
      "Documentation",
      "Cyber Security",
      "Cyber Awareness",
      "Collaboration",
      "Organizational Communication",
      "Presentation",
    ],
    doc: "https://drive.google.com/file/d/1ETK_ab9_hjN4Wn6niRvJtahL45XFHB8N/view?usp=sharing",
    icon: "https://img.freepik.com/premium-vector/certificate-icon-with-ribbon-medal-flat-design_115464-65.jpg",
  },
];

export const education = [
  {
    id: 0,
    img: "https://www.gitam.edu/sites/default/files/2022-09/GITAM-logo.jpg",
    school: "Gandhi Institute of Technology and Management, Hyderabad",
    date: "Oct 2020 - May 2024",
    grade: "9.41 CGPA",
    desc: "Pursuing a Bachelor's degree in Computer Science and Engineering at Gandhi Institute of Technology and Management, Hyderabad. I have completed 7 semesters and have a CGPA of 9.41. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, Blockchain Technology, Cryptography and Network Security, Mobile Application Security among others. I have had the opportunity of collaborating with distinguished professors and learning so much from them through my university",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://directory.edugorilla.com/wp-content/uploads/sites/6/2016/03/ddddd.jpg",
    school: "Deeksha Junior College, Miyapur",
    date: "June 2018 - Apr 2020",
    grade: "92.1%",
    desc: "I completed my Intermediate High School Education at Deeksha Junior College, Miyapur, where I opted for the subjects Mathematics, Physics and Chemistry (MPC) along with languages such as Sanskrit and English",
    degree:
      "Intermediate MPC - Telanagana State Board of Intermediate Education",
  },
  {
    id: 2,
    img: "https://www.schoolmykids.com/smk-media/2019/06/Genesis-School-Miyapur-Hyderabad.png",
    school: "Genesis International School, Madinaguda",
    date: "Jun 2014 - May 2018",
    grade: "82%",
    desc: "I completed my class 10 education at Genesis International School, Madinaguda, where I got my foundation in academics and also developed a deep interest for various extra-curricular activities such as Cricket, Table Tennis, Badminton and Athletics.",
    degree: "Schooling - Grade 7 to Grade 10",
  },
];

export const projects = [
  {
    id: 9,
    title: "Medical Report Management and Distribution System on Blockchain",
    date: "Aug 2023 - Oct 2023",
    description:
      "MRMD is a web application that is a cutting-edge solution for efficient medical report management. It's about securely managing medical records on the blockchain, ensuring secure and decentralised access, data immutability and enhancing transparency in healthcare services. It provides a user-friendly interface for doctors, pathologists, pharmacists and patients to keep track of their details and daily work activities and empowers patients.",
    image: mrmd,
    tags: [
      "Blockchain",
      "HTML",
      "CSS",
      "Javascript",
      "ReactJS",
      "ThirdWeb",
      "Metamask",
      "Solidity",
      "IPFS",
      "Goerli Etherscan",
    ],
    category: "web app",
    github:
      "https://github.com/akhilx26/Medical-Report-Management-and-Distribution-System-Web3",
    webapp:
      "https://github.com/akhilx26/Medical-Report-Management-and-Distribution-System-Web3",
    member: [
      {
        name: "Akhil Ben Thomas",
        img: "https://thumbs.dreamstime.com/b/vector-illustration-avatar-dummy-logo-collection-image-icon-stock-isolated-object-set-symbol-web-137160339.jpg",
        linkedin: "https://www.linkedin.com/in/akhil-ben-thomas-b02304216/",
        github: "https://github.com/akhilx26",
      },
      {
        name: "Ruthvik Mantripragada",
        img: "https://thumbs.dreamstime.com/b/vector-illustration-avatar-dummy-logo-collection-image-icon-stock-isolated-object-set-symbol-web-137160339.jpg",
        linkedin: "https://www.linkedin.com/in/ruthvik-m/",
        github: "https://github.com/Ruthvik3113",
      },
    ],
  },
  {
    id: 0,
    title: "Appointment Booking System",
    date: "Jul 2023 - Aug 2023",
    description:
      "Developed a full-stack web application that allows users to book appointments by selecting a favorable time slot with interactive and responsive UI.",
    image: Appbooksys,
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "RESTful APIs",
      "Bootstrap",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/akhilx26/Appointment-Booking-System",
    webapp: "https://appointment-booking-system-006.netlify.app/",
  },
  {
    id: 1,
    title: "To-Do List",
    date: "Aug 2022",
    description:
      "This To-Do List Software Application helps users to create, organize, and track tasks. It can be used to manage personal tasks, work tasks, or a combination of both. and can be a valuable tool for helping users to stay organized and productive.",
    image: "https://ik.imagekit.io/freshman/empty-state-bug_BfM19uFhs.gif",
    tags: ["HTML", "CSS", "Javascript", "Bootstrap", "MongoDB"],
    category: "web app",
    github: "https://github.com/akhilx26/ToDo-List",
    webapp: "https://github.com/akhilx26/ToDo-List",
  },
];

//   export const TimeLineData = [
//     { year: 2017, text: "Started my journey" },
//     { year: 2018, text: "Worked as a freelance developer" },
//     { year: 2019, text: "Founded JavaScript Mastery" },
//     { year: 2020, text: "Shared my projects with the world" },
//     { year: 2021, text: "Started my own platform" },
//   ];
